export const WORKSHOP_STEPS = [
  {
    id: 0,
    title: "Context: The Trap",
    headline: "2,600 products is a trap. Design for revenue, not coverage.",
    content:
      "If everything is taught, nothing is retained. Success relies on strategic prioritization, not comprehensive coverage. We must limit V1 scope to what is maintainable.",
    visualType: "funnel",
    actions: ["Acknowledge Constraint"],
  },
  {
    id: 1,
    title: "Frame the Decision",
    headline: "Align leadership on the goal.",
    content:
      "We are not deciding what matters overall. We are deciding which products require baseline education to support revenue outcomes in the next 2 quarters.",
    visualType: "comparison",
    copyBlock: {
      label: "Workshop Invite",
      text: "Goal: Agree on the 15–20 products that require baseline education for V1 onboarding. This is not a coverage exercise—this is a revenue + retention exercise.",
    },
  },
  {
    id: 2,
    title: "Roles & Horizon",
    headline: "Lock V1 Scope Boundaries.",
    content:
      "David indicated AE and Specialist are the priority. We focus on Onboarding (First 30 Days) and Launch spikes.",
    visualType: "toggles",
  },
  {
    id: 3,
    title: "Define Criteria",
    headline: "Pick 4 criteria to stop the debate.",
    content: "Agree on the scoring rubric before discussing specific products.",
    visualType: "criteria_selector",
  },
  // --- NEW STEP: THE DATA HUNT ---
  {
    id: 4,
    title: "The Data Hunt",
    headline: "Don't guess. Triangulate.",
    content:
      "You won't find a single 'Strategic List' waiting for you. You must hunt for it across these 4 data silos (RevOps, Product, Support, SEs). If a product doesn't appear in this data, it is likely not a priority.",
    visualType: "data_hunter",
    copyBlock: {
      label: "Ask RevOps (Email Template)",
      text: "Can you please pull a report of 'Closed-Won Revenue by Product SKU' for the trailing 12 months? I want to apply the Pareto Principle (80/20) to identify our true revenue drivers for the new curriculum.",
    },
  },
  {
    id: 5,
    title: "Score & Slice",
    headline: "Role relevance matters more than rank.",
    content:
      "A product might be #1 for revenue but require zero education. A complex product might be #50 but require deep training. Map to roles.",
    visualType: "scoring_table",
  },
  {
    id: 6,
    title: "The Final Cut",
    headline: "Force the decision: 15-20 Max.",
    content:
      "Target 5-8 products per role for onboarding. Anything more becomes noise.",
    visualType: "final_list",
  },
  {
    id: 7,
    title: "Translate to ALM",
    headline: "Make it real.",
    content:
      "Convert the approved list into ALM governance objects (Tags, Templates, Paths).",
    visualType: "alm_blueprint",
    copyBlock: {
      label: "Leadership Update",
      text: "Strategic Product Scope is defined and locked. We aligned on a focused Strategic Product List (17 products) based on revenue impact and complexity. Product Education will build standardized ALM modules only for these products, mapped by role (AE vs Specialist). This prevents content sprawl and improves retention.",
    },
  },
];
